import { Navigate, useNavigate } from 'react-router-dom';
import { ArrowRight, Handshake, LockKeyhole, ShieldCheck } from 'lucide-react';
import { useDemo } from '../state';
import { AppShell } from '../layout';

export function LoginPage() {
  const { state, dispatch } = useDemo();
  const navigate = useNavigate();

  if (state.loggedIn) return <Navigate to="/soknad/prosjekt" replace />;

  const login = () => {
    dispatch({ type: 'LOGIN' });
    navigate('/soknad/prosjekt');
  };

  return (
    <AppShell wide>
      <section className="in-login">
        <div className="in-login__intro">
          <p className="in-kicker">SmartNorge</p>
          <h1>Søk støtte til å ta en dokumentert løsning videre.</h1>
          <p className="in-lead">
            SmartNorge er en tilskuddsordning for kommunale pilotprosjekter.
          </p>
          <div className="in-login__facts">
            <div>
              <ShieldCheck aria-hidden="true" />
              <span>Virksomheten representeres med ID-porten</span>
            </div>
            <div>
              <Handshake aria-hidden="true" />
              <span>Start søknaden uten kommunesamarbeid og finn samarbeidspartnere i prosjektoversikten.</span>
            </div>
          </div>
        </div>

        <div className="in-login-card">
          <span className="in-login-card__mark" aria-hidden="true" />
          <p className="in-kicker">Start søknaden</p>
          <h2>Logg inn på vegne av virksomheten</h2>
          <p>Du blir logget inn som daglig leder i EcoWaste Tech AS i denne demoen.</p>
          <button type="button" className="in-primary-button in-primary-button--large" onClick={login}>
            <LockKeyhole aria-hidden="true" />
            Logg inn med ID-porten
            <ArrowRight aria-hidden="true" />
          </button>
          <p className="in-login-card__note">Simulert innlogging. Ingen personopplysninger behandles.</p>
        </div>
      </section>
    </AppShell>
  );
}
